// src/utils/apiFetch.js
// 인증 API 공용 fetch — Authorization 자동 부착, 401(세션 만료) 공통 처리.
// 로그인 요청(/auth/**)은 이 헬퍼를 쓰지 않는다 (토큰 이전 단계라 401 의미가 다름).
import { getAuthToken, clearSession } from './storageUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiFetch = async (path, options = {}) => {
    const headers = { ...options.headers };
    const token = getAuthToken();
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    if (options.body && !headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });

    if (response.status === 401) {
        clearSession();
        window.location.href = '/login?expired=1';
        // 하드 리다이렉트가 즉시 이어지므로, 호출부 catch가 엉뚱한 토스트를 띄우지 않게 영구 대기
        return new Promise(() => {});
    }
    return response;
};
